import { HTTP } from './httpCommon';

export const httpGet = {

  ////////////////////////////////////////////
  ///ACCOUNTS
  ////////////////////////////////////////////

  //Get Accounts
  getAccounts(callback) {
    HTTP.get('Accounts')
      .then(response => {
        // JSON responses are automatically parsed.
        callback(response.data)
      })
      .catch(e => {
        //this.errors.push(e)
      })
  },


  ////////////////////////////////////////////
  ///INCOMES
  ////////////////////////////////////////////

  //Get Incomes
  getIncomes(callback) {
    HTTP.get('Incomes')
      .then(response => {
        // JSON responses are automatically parsed.
        callback(response.data)
      })
      .catch(e => {
        //this.errors.push(e)
      })
  },


   ////////////////////////////////////////////
  ///EXPENSES
  ////////////////////////////////////////////

  //Get Expenses
  getExpenses(callback) {
    HTTP.get('Expenses')
      .then(response => {
        // JSON responses are automatically parsed.
        callback(response.data)
      })
      .catch(e => {
        //this.errors.push(e)
      })
  }



}



// WEBPACK FOOTER //
// ./src/api/httpGet.js